<template>
    <div class="bg-white" style="border: solid 1px #8f8f8f;">
        <div class="d-none d-sm-flex row mx-0 px-2" style="background-color: #323336">
            <div class="col-2 col-sm-1 px-1">
                <span class="d-none d-lg-block small text-uppercase text-white">Domain</span>
                <span class="d-block d-lg-none small text-uppercase text-white">Dom.</span>
            </div>
            <div class="col-2 col-sm-1 px-1">
                <span class="d-none d-lg-block small text-uppercase text-white">Updated</span>
                <span class="d-block d-lg-none small text-uppercase text-white">Upd.</span>
            </div>
            <div class="col-4 col-sm-2 px-1">
                <span class="d-block small text-uppercase text-white">Goal title</span>
            </div>
            <div class="col-6 col-sm-5 px-1">
                <span class="d-block small text-uppercase text-white">Goal description</span>
            </div>
            <div class="col-9 col-sm-2 px-1">
                <span class="d-none d-lg-block small text-uppercase text-white"
                    >Method trackers</span
                >
                <span class="d-block d-lg-none small text-uppercase text-white">Method trk.</span>
            </div>
            <div class="col-1 col-sm-1 px-1">
                <span class="small text-uppercase text-white"></span>
            </div>
        </div>

        <form
            @submit.prevent="addGoalToPatient"
            style=" background:#fff5f8;"
            v-if="canAddEditGoals"
        >
            <div v-if="goalStatusFilter < 2" class="row px-4 py-1 py-sm-0 px-sm-3">
                <h5 class="d-sm-none text-uppercase font-weight-bold">Add goal</h5>
                <div class="p-1 col-12 col-sm-2">
                    <div class="form-group row mb-0">
                        <label
                            for="domain"
                            class="d-inline-block d-sm-none col-3 font-weight-bold col-form-label"
                            >Domain:
                        </label>
                        <div class="col-9 col-sm-12">
                            <select
                                dusk="domain"
                                class="form-control form-control-sm"
                                v-model="domain"
                                name="domain"
                                id="domain"
                            >
                                <option value="" disabled hidden :value="null">Domain</option>
                                <option v-for="domain in domains" :value="domain.id">
                                    {{ domain.name }}
                                </option>
                            </select>
                        </div>
                    </div>
                </div>
                <div class="p-1 col-12 col-sm-2">
                    <div class="form-group row mb-0">
                        <label
                            for="title"
                            class="d-inline-block d-sm-none col-3 font-weight-bold col-form-label"
                            >Title:
                        </label>
                        <div class="col-9 col-sm-12">
                            <input
                                class="form-control form-control-sm"
                                v-model="title"
                                name="title"
                                type="text"
                                maxlength="255"
                                id="title"
                                placeholder="max. 25 characters"
                                autocomplete="off"
                            />
                        </div>
                    </div>
                </div>
                <div class="p-1 col-12 col-sm-5">
                    <div class="form-group row mb-0">
                        <label
                            for="description"
                            class="d-inline-block d-sm-none col-3 font-weight-bold col-form-label"
                            >Description:
                        </label>
                        <div class="col-9 col-sm-12">
                            <textarea
                                class="form-control"
                                v-model="description"
                                name="description"
                                id="description"
                                rows="3"
                                placeholder="Write your goal"
                            ></textarea>
                        </div>
                    </div>
                </div>
                <div class="p-1 col-12 col-sm-3">
                    <div class="form-group row mb-0">
                        <label
                            for="description"
                            class="d-inline-block d-sm-none col-3 font-weight-bold col-form-label"
                            >Tracker type:
                        </label>
                        <div class="col-9 col-sm-12">
                            <select
                                v-model="tracker_type"
                                class="form-control form-control-sm"
                                name="tracker_type"
                                id="trackers"
                                required="required"
                            >
                                <option
                                    v-if="tracker.type !== 'soap_note' && tracker.is_active"
                                    v-for="tracker in trackers"
                                    v-bind:value="tracker.type"
                                >
                                    {{ tracker.formatted_name }}
                                </option>
                            </select>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row px-3 py-1" v-show="['percent', 'multi_percent'].includes(tracker_type)">
                <div class="col-12 d-flex justify-content-end">
                    <span class="mb-0"><small>Number of attempts</small></span>
                    <span
                        class="form-check form-check-inline cursor-pointer"
                        @click="$set(parameters, 'attempts_number', 'free')"
                        id="percent-free"
                    >
                        <i
                            dusk="percent_free"
                            class="fa fa-lg fa-fw pr-1 cursor-pointer text-primary"
                            :class="
                                parameters.hasOwnProperty('attempts_number') &&
                                parameters.attempts_number === 'free'
                                    ? 'fa-dot-circle-o'
                                    : 'fa-circle-o'
                            "
                        ></i>
                        <small class="font-italic">free</small>
                    </span>
                    <span
                        class="form-check form-check-inline"
                        id="percent-fixed"
                        @click="$set(parameters, 'attempts_number', 'fixed')"
                    >
                        <i
                            dusk="percent_fixed"
                            class="fa fa-lg fa-fw pr-1 cursor-pointer text-primary"
                            :class="
                                parameters.hasOwnProperty('attempts_number') &&
                                parameters.attempts_number === 'fixed'
                                    ? 'fa-dot-circle-o'
                                    : 'fa-circle-o'
                            "
                        ></i>
                        <small class="font-italic">fixed</small>
                    </span>
                </div>

                <div class="col-12 d-flex justify-content-end">
                    <div v-show="parameters.attempts_number === 'fixed'">
                        <span class="font-italic small muted mr-2">Goal: </span>
                        <input
                            dusk="percent_success"
                            v-model.number="parameters.success"
                            name="success"
                            type="text"
                            class="d-inline form-control form-control-sm"
                            style="max-width: 2.5rem; line-height: 0.5;"
                        />
                        <span class="font-italic small muted mr-2">of</span>
                        <input
                            dusk="percent_attempts"
                            v-model.number="parameters.attempts"
                            name="attempts"
                            class="d-inline form-control form-control-sm"
                            type="text"
                            style="max-width: 2.5rem; line-height: 0.5;"
                        />
                        <span class="font-italic small muted">attempts</span>
                    </div>
                    <div v-show="parameters.attempts_number === 'free'">
                        <span class="font-italic small muted mr-2">Success: </span>
                        <input
                            dusk="percent_percent"
                            v-model.number="parameters.percent"
                            name="percent"
                            class="d-inline form-control form-control-sm"
                            type="text"
                            style="max-width: 3rem; line-height: 0.5;"
                        />
                        <span class="font-italic small muted">%</span>
                    </div>
                </div>
                <div
                    class="col-12 d-flex justify-content-end"
                    v-if="['multi_percent'].includes(tracker_type)"
                >
                    <goals-target-list
                        v-model="targets"
                        :title="`Add target <em>i.e. 'Frog, Fox, Fan, Family, Friend'</em>:`"
                        :align-right="true"
                    ></goals-target-list>
                </div>
            </div>

            <div class="row px-3 py-1" v-if="tracker_type === 'preference_assessment'">
                <div class="col-12 text-right">
                    <div class="form-inline d-flex justify-content-end">
                        <label class="small  mr-2" for="pa_method">Method: </label>
                        <select
                            class="form-control form-control-sm"
                            v-model="parameters.method"
                            name="pa_method"
                            id="pa_method"
                        >
                            <option value="" disabled hidden :value="null">Method</option>
                            <option v-for="m in filteredPreferenceAssessment" :value="m.type">
                                {{ m.description }}
                            </option>
                        </select>
                    </div>
                    <goals-target-list
                        v-model="targets"
                        :title="`Add item:`"
                        :align-right="true"
                    ></goals-target-list>
                </div>
            </div>

            <div class="row px-3 py-1" v-if="tracker_type === 'tally'">
                <div class="col-12 text-right">
                    <div>
                        <input
                            v-model.number="parameters.success"
                            name="success"
                            id="tally-success"
                            type="text"
                            class="d-inline form-control form-control-sm"
                            style="max-width: 2rem; line-height: 0.5;"
                        />
                        <span class="font-italic small  mr-2">mastery criteria</span>
                        <span
                            v-tooltip="
                                'Check if the objective is to have this value decrease over sessions'
                            "
                        >
                            <i
                                class="fa fa-lg fa-fw pr-1 cursor-pointer text-primary"
                                id="tally-decrease"
                                :class="
                                    parameters.hasOwnProperty('decreasing') && parameters.decreasing
                                        ? 'fa-check-square-o'
                                        : 'fa-square-o'
                                "
                                @click="
                                    parameters.hasOwnProperty('decreasing') && parameters.decreasing
                                        ? $set(parameters, 'decreasing', false)
                                        : $set(parameters, 'decreasing', true)
                                "
                            ></i>
                            <label class="mb-0" for="tally-decrease">
                                <span class="small font-italic">Decreasing?</span>
                            </label>
                        </span>
                    </div>
                    <div>
                        <em><span class="small "> Time limit (optional): </span></em>
                        <time-input v-model="parameters.time_limit"></time-input>
                    </div>
                </div>
            </div>

            <div class="row px-3 py-1" v-if="tracker_type === 'duration'">
                <div class="col-12 text-right">
                    <em><span class="small "> Goal: </span></em>
                    <time-input v-model="parameters.success"></time-input>
                    <p class="mb-0 font-italic small mr-2">
                        Show results as:
                        <span class="form-check form-check-inline">
                            <i
                                class="fa fa-lg fa-fw pr-1 cursor-pointer text-primary"
                                id="duration-average"
                                :class="
                                    parameters.hasOwnProperty('evaluate') &&
                                    parameters.evaluate === 'average'
                                        ? 'fa-dot-circle-o'
                                        : 'fa-circle-o'
                                "
                                @click="$set(parameters, 'evaluate', 'average')"
                            ></i>
                            <span class="">average time</span>
                        </span>
                        <span class="form-check form-check-inline">
                            <i
                                class="fa fa-lg fa-fw pr-1 cursor-pointer text-primary"
                                id="duration-max"
                                :class="
                                    parameters.hasOwnProperty('evaluate') &&
                                    parameters.evaluate === 'max'
                                        ? 'fa-dot-circle-o'
                                        : 'fa-circle-o'
                                "
                                @click="$set(parameters, 'evaluate', 'max')"
                            ></i>
                            <span class="">longest time</span>
                        </span>
                    </p>

                    <div>
                        <i
                            class="fa fa-lg fa-fw pr-1 cursor-pointer text-primary"
                            id="duration-intensity"
                            :class="
                                parameters.hasOwnProperty('track_intensity') &&
                                parameters.track_intensity
                                    ? 'fa-check-square-o'
                                    : 'fa-square-o'
                            "
                            @click="
                                parameters.hasOwnProperty('track_intensity') &&
                                parameters.track_intensity
                                    ? $set(parameters, 'track_intensity', false)
                                    : $set(parameters, 'track_intensity', true)
                            "
                        ></i>
                        <label class="mb-0" for="tally-decrease">
                            <span class="small font-italic">Track intensity?</span>
                        </label>
                    </div>
                </div>
            </div>

            <div class="row px-3 py-1" v-if="tracker_type === 'cme'">
                <div class="col-12 text-right">
                    <small class="">Goal: </small
                    ><input
                        v-model.number="parameters.success"
                        name="success"
                        type="text"
                        class="d-inline form-control form-control-sm"
                        style="max-width: 3rem; line-height: 0.5;"
                    />
                    <span class="form-check form-check-inline">
                        <i
                            class="fa fa-lg fa-fw pr-1 cursor-pointer text-primary"
                            id="cme-average"
                            :class="
                                parameters.hasOwnProperty('evaluate') &&
                                parameters.evaluate === 'average'
                                    ? 'fa-dot-circle-o'
                                    : 'fa-circle-o'
                            "
                            @click="$set(parameters, 'evaluate', 'average')"
                        ></i>
                        <span class="small font-italic">average</span>
                    </span>
                    <span class="form-check form-check-inline">
                        <i
                            class="fa fa-lg fa-fw pr-1 cursor-pointer text-primary"
                            id="cme-max"
                            :class="
                                parameters.hasOwnProperty('evaluate') &&
                                parameters.evaluate === 'max'
                                    ? 'fa-dot-circle-o'
                                    : 'fa-circle-o'
                            "
                            @click="$set(parameters, 'evaluate', 'max')"
                        ></i>
                        <span class="small font-italic">highest</span>
                    </span>
                </div>
            </div>

            <div class="row px-3 py-1" v-if="tracker_type === 'cold_probe'">
                <div class="col-12 text-right">
                    <span class="small ">% mastery criteria: </span
                    ><input
                        v-model.number="parameters.goal"
                        id="cold-probe-success"
                        name="success"
                        type="text"
                        class="d-inline form-control form-control-sm"
                        style="max-width: 3rem; line-height: 0.5;"
                    />
                    <goals-target-list v-model="targets" :align-right="true"></goals-target-list>
                </div>
            </div>

            <div class="row px-3 py-1" v-if="tracker_type === 'articulation'">
                <div class="col-12 text-right">
                    <span class="small ">% mastery criteria: </span
                    ><input
                        v-model.number="parameters.success"
                        name="success"
                        type="text"
                        class="d-inline form-control form-control-sm"
                        style="max-width: 3rem; line-height: 0.5;"
                    />
                    <goals-target-list
                        v-model="targets"
                        :title="`Add target <em>i.e. 'Frog, Fox, Fan, Family, Friend'</em>:`"
                        :align-right="true"
                    ></goals-target-list>
                </div>
            </div>

            <div class="row px-3 py-1" v-if="tracker_type === 'multi_tally'">
                <div class="col-12 text-right">
                    <span class="small mr-2">Mastery criteria:</span>
                    <input
                        v-model.number="parameters.success"
                        name="success"
                        type="text"
                        class="d-inline form-control form-control-sm text-right"
                        style="max-width: 3rem; line-height: 0.5;"
                    />
                    <span
                        v-tooltip="
                            'Check if the objective is to have this value decrease over sessions'
                        "
                    >
                        <i
                            class="fa fa-lg fa-fw pr-1 cursor-pointer text-primary"
                            id="multi-tally-decrease"
                            :class="
                                parameters.hasOwnProperty('decreasing') && parameters.decreasing
                                    ? 'fa-check-square-o'
                                    : 'fa-square-o'
                            "
                            @click="
                                parameters.hasOwnProperty('decreasing') && parameters.decreasing
                                    ? $set(parameters, 'decreasing', false)
                                    : $set(parameters, 'decreasing', true)
                            "
                        ></i>
                        <label class="mb-0" for="tally-decrease">
                            <span class="small font-italic">Decreasing?</span>
                        </label>
                    </span>
                    <div>
                        <em><span class="small "> Time limit (optional): </span></em>
                        <time-input v-model="parameters.time_limit"></time-input>
                    </div>
                    <goals-target-list v-model="targets" :align-right="true"></goals-target-list>
                </div>
            </div>

            <div class="row px-3 py-1" v-if="tracker_type === 'mand'">
                <div class="col-6">
                    <span class="small">Minimum mands per session </span>
                    <input
                        v-model.number="parameters.mand_opportunities"
                        name="mand_opp"
                        type="text"
                        class="d-inline form-control form-control-sm"
                        style="max-width: 3rem; line-height: 0.5;"
                    />
                    <span class="small "> and % mastery criteria </span>
                    <input
                        v-model.number="parameters.success"
                        @input="parameters.success > 100 ? (parameters.success = 100) : null"
                        name="success"
                        type="text"
                        class="d-inline form-control form-control-sm"
                        style="max-width: 3rem; line-height: 0.5;"
                    />
                </div>
                <div class="col-6">
                    <goals-target-list
                        v-model="targets"
                        :title="`Add target <em>i.e. Eye Contact, 'Negative Behavior Present'`"
                        :align-right="true"
                    ></goals-target-list>
                </div>
            </div>

            <div class="row px-3 py-1" v-if="tracker_type === 'mand_echoic'">
                <div class="col-6">
                    <span class="small">Mand: </span>
                    <input
                        v-model.number="parameters.success"
                        @input="parameters.success > 100 ? (parameters.success = 100) : null"
                        name="success"
                        type="text"
                        class="d-inline form-control form-control-sm"
                        style="max-width: 3rem; line-height: 0.5;"
                    />
                    <span class="small">% of </span>
                    <input
                        v-model.number="parameters.mand_opportunities"
                        name="mand_opp"
                        type="text"
                        class="d-inline form-control form-control-sm"
                        style="max-width: 3rem; line-height: 0.5;"
                    />
                    <span class="small">opportunities</span>
                    <div>
                        <span class="small"># repetitions: </span
                        ><input
                            v-model.number="parameters.echoic_repetitions"
                            v-mask="'##'"
                            name="echoic_rpt"
                            type="text"
                            class="d-inline form-control form-control-sm"
                            style="max-width: 3rem; line-height: 0.5;"
                        /><br />
                        <span class="small"># for success: </span
                        ><input
                            v-model.number="parameters.echoic_repetitions_success"
                            v-mask="'##'"
                            name="echoic_rpt"
                            type="text"
                            class="d-inline form-control form-control-sm"
                            style="max-width: 3rem; line-height: 0.5;"
                        />
                    </div>
                </div>
                <div class="col-6">
                    <goals-target-list
                        v-model="targets"
                        :title="
                            `Add target <em>i.e. Eye Contact, 'Negative Behavior Present'</em>:`
                        "
                        :align-right="true"
                    ></goals-target-list>
                </div>
            </div>

            <div class="row px-3 py-1" v-if="tracker_type === 'task_analysis'">
                <div class="col-12 text-right">
                    <span class="small">% mastery criteria: </span
                    ><input
                        v-model.number="parameters.success"
                        name="success"
                        type="text"
                        class="d-inline form-control form-control-sm"
                        style="max-width: 3rem; line-height: 0.5;"
                    /><small class=""></small>
                    <goals-target-list
                        v-model="targets"
                        :title="`Steps:`"
                        :align-right="true"
                    ></goals-target-list>
                </div>
            </div>

            <div class="row px-3 py-1" v-if="tracker_type === 'time_sampling'">
                <div class="col-12 text-right">
                    <div class="form-inline d-flex justify-content-end">
                        <label class="small  mr-2" for="pa_method">Method: </label>
                        <select
                            class="form-control form-control-sm"
                            v-model="parameters.method"
                            name="method"
                            id="method_ts"
                        >
                            <option value="" selected disabled hidden :value="null">Method</option>
                            <option v-for="m in timeSamplingMethods" :value="m.type">
                                {{ m.description }}
                            </option>
                        </select>
                    </div>
                    <div class="">
                        <span class="small  mr-2">Number of intervals:</span>
                        <input
                            v-model.number="parameters.intervals"
                            v-mask="'##'"
                            name="intervals"
                            type="text"
                            class="d-inline form-control form-control-sm mr-2"
                            style="max-width: 2rem; line-height: 0.5;"
                        />
                        <span class="small ">Success: </span>
                        <input
                            v-model.number="parameters.success"
                            v-mask="'##'"
                            name="success"
                            type="text"
                            class="d-inline form-control form-control-sm"
                            style="max-width: 2rem; line-height: 0.5;"
                        />
                    </div>
                    <div>
                        <span class="small ">Interval length: </span>
                        <time-input v-model="parameters.interval_length"></time-input>
                    </div>
                    <div>
                        <span class="small"
                            >Total time:
                            {{
                                moment()
                                    .startOf("day")
                                    .seconds(parameters.interval_length || 0)
                                    .format("H:mm:ss")
                            }}</span
                        >
                    </div>
                </div>
            </div>

            <div class="row px-3">
                <div class="col-12 p-1 d-flex justify-content-end">
                    <div>
                        <span
                            class="form-check form-check-inline"
                            id="is_shared"
                            @click="is_shared ? (is_shared = 0) : (is_shared = 1)"
                        >
                            <i
                                dusk="is_shared"
                                class="fa fa-lg fa-fw pr-1 cursor-pointer text-primary"
                                :class="is_shared ? 'fa-check-square' : 'fa-square-o'"
                            ></i>
                            <span class=""
                                >Make this goal shared
                                <i
                                    v-tooltip="
                                        `By making this goal is shared, every therapist assigned to ${
                                            patient.name
                                        } will be able to alter details and parameters, archive or delete this goal.`
                                    "
                                    class="fa fa-lg fa-info-circle text-info"
                                ></i
                            ></span>
                        </span>
                    </div>
                    <button
                        dusk="add_goal"
                        id="add_goal"
                        class="btn btn-sm btn-primary text-white text-uppercase"
                        v-show="goalStatusFilter < 2"
                        @click.prevent="addGoalToPatient()"
                    >
                        <i
                            class="fa fa-fw"
                            :class="loading ? 'fa-spin fa-circle-o-notch' : 'fa-plus'"
                        ></i>
                        <span>Add Goal</span>
                    </button>
                </div>
            </div>

            <div class="row px-3" v-if="failedSubmit">
                <div class="col-12 p-1 d-flex justify-content-end">
                    <small class="text-primary font-italic">Please complete all fields.</small>
                </div>
            </div>

            <div class="row px-3" v-if="serverErrors">
                <div class="col-12 p-1 d-flex justify-content-end" v-for="error in serverErrors">
                    <small class="text-primary font-italic">{{ error }}</small>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
import GoalsTargetList from "./GoalsTargetList";
import TimeInput from "../ui/TimeInput";
import { permissions } from "../../plugins/permissions";

export default {
    name: "GoalsNew",
    components: { GoalsTargetList, TimeInput },
    props: [
        "organization",
        "goalStatusFilter",
        "patient",
        "organizationId",
        "userId",
        "domains",
        "trackers",
    ],
    mixins: [permissions],
    data() {
        return {
            title: null,
            is_shared: 0,
            domain: null,
            description: null,
            tracker_type: null,
            parameters: {
                success: 0,
                attempts: 0,
            },
            target: null,
            percent: null,
            targets: [],
            progress: 0,
            preferenceAssessmentMethods: [
                { type: "paired", description: "Paired" },
                { type: "single", description: "Single" },
                { type: "mswo", description: "Multiple Stimulus without Replacement" },
                { type: "msw", description: "Multiple Stimulus with Replacement" },
                { type: "free_operant", description: "Free Operant" },
            ],
            failedSubmit: false,
            loading: false,
            serverErrors: [],
        };
    },
    watch: {
        percent: function(val) {
            // TODO: do validation on percent. Make sure it's a positive number. This can be done with a Vue mask like we did with minutes and seconds.
            // TODO: we can get rid of this by doing this calculation in addGoalToPatient
            if (this.parameters.attempts) {
                this.parameters.success = Math.round(val / this.parameters.attempts);
            } else {
                // TODO: maybe we should only show the percentage field iff the number of attempts is set. Or if we do the calculation in addGoalToPatient we don't have to worry about this -- assuming we are using vee-validate.
                alert("Please set the number of attempts before setting a percentage");
            }
        },
    },
    computed: {
        filteredPreferenceAssessment() {
            const preferenceAssessmentCustomization = this.trackers.find(
                t => t.type === "preference_assessment"
            );
            if (
                preferenceAssessmentCustomization.default_options &&
                preferenceAssessmentCustomization.default_options.hasOwnProperty("types")
            ) {
                const customizedTypes = preferenceAssessmentCustomization.default_options.types;
                customizedTypes.forEach(t => {
                    if (!t.active) {
                        const index = this.preferenceAssessmentMethods.indexOf(
                            this.preferenceAssessmentMethods.find(m => m.type === t.name)
                        );
                        this.preferenceAssessmentMethods.splice(index, 1);
                    }
                });
            }
            return this.preferenceAssessmentMethods;
        },

        timeSamplingMethods() {
            return [
                {
                    type: "partial_interval",
                    description: "Partial Interval",
                },
                {
                    type: "whole_interval",
                    description: "Whole Interval",
                },
                {
                    type: "momentary_time_sampling",
                    description: "Momentary Time Sampling",
                },
            ];
        },
    },
    methods: {
        validateNewGoal() {
            if (
                !this.domain ||
                !this.title ||
                !this.description ||
                (![
                    "preference_assessment",
                    "cold_probe",
                    "percent",
                    "multi_percent",
                    "tally",
                    "multi_tally",
                    "time_sampling",
                ].includes(this.tracker_type) &&
                    !this.parameters.success)
            ) {
                return false;
            }
            // TODO: move each goal type into their own components. This will make the code much more readable. Same thing with addGoalToPatient()
            switch (this.tracker_type) {
                case "percent":
                    return (
                        (this.parameters.attempts && this.parameters.success) ||
                        this.parameters.percent
                    );
                case "tally":
                    return (
                        (this.parameters.decreasing && !isNaN(this.parameters.success)) ||
                        !isNaN(this.parameters.success)
                    );
                case "multi_tally":
                    return (
                        ((this.parameters.decreasing && !isNaN(this.parameters.success)) ||
                            !isNaN(this.parameters.success)) &&
                        this.targets.length
                    );
                case "cme":
                    return this.parameters.evaluate;
                case "multi_percent":
                    return (
                        ((this.parameters.attempts && this.parameters.success) ||
                            this.parameters.percent) &&
                        this.targets.length
                    );
                case "articulation":
                case "task_analysis":
                case "preference_assessment":
                    return this.targets.length;
                case "mand":
                case "mand_echoic":
                    return this.parameters.mand_opportunities;
                case "cold_probe":
                    return this.parameters.goal;
                case "duration":
                    return this.parameters.success > 0 && this.parameters.evaluate;
                case "time_sampling":
                    return (
                        this.parameters.interval_length > 0 &&
                        !isNaN(this.parameters.intervals) &&
                        this.parameters.method &&
                        this.parameters.success <= this.parameters.intervals
                    );
                default:
                    return true;
            }
        },
        addGoalToPatient() {
            if (!this.validateNewGoal()) {
                this.failedSubmit = true;
                return;
            } else {
                this.failedSubmit = false;
            }

            this.parameters.type = this.tracker_type;
            // TODO: convert this to a switch statement
            if (["percent"].includes(this.tracker_type)) {
                if (this.parameters.attempts_number === "free") {
                    this.parameters.attempts = 0;
                    this.parameters.success = this.parameters.percent;
                    delete this.parameters.percent;
                }
                delete this.parameters.attempts_number;
            }
            if (["tally", "multi_tally"].includes(this.tracker_type)) {
                if (this.parameters.time_limit === 0) {
                    delete this.parameters.time_limit;
                }
            }
            if (["articulation", "multi_percent", "multi_tally"].includes(this.tracker_type)) {
                this.parameters.targets = this.targets;
            }
            if (["task_analysis"].includes(this.tracker_type)) {
                this.parameters.steps = this.targets;
            }
            if (["preference_assessment"].includes(this.tracker_type)) {
                this.parameters.items = this.targets;
            }
            if (["mand_echoic", "mand"].includes(this.tracker_type)) {
                this.parameters.parameters = this.targets;
            }
            if (["cold_probe"].includes(this.tracker_type)) {
                this.parameters = {
                    ...this.parameters,
                    type: "cold_probe",
                    success: 100,
                    baseline_num_times_repeat_question: 3,
                    baseline_considered_mastered: 3,
                    teaching_num_times_repeat_question: 3,
                    teaching_is_consecutive_days_required: true,
                    retention_num_days_reprobe: 7,
                    tracker_auto_probe_appear: true,
                    therapist_can_add_targets: false,
                    therapist_can_track_probes: true,
                    targets: [],
                };
                if (this.targets.length === 0) {
                    this.targets.push("Cookie");
                }

                this.targets.forEach(t => {
                    this.parameters.targets.push({
                        name: t,
                        introduced: null,
                        acquired: null,
                        retained: null,
                        updated: this.moment().format("YYYY-MM-DD"),
                        stage: "baseline",
                        baseline: [],
                        teaching: [],
                        mastered: false,
                        next_probe: null,
                        progress: 0,
                    });
                });
            }

            this.loading = true;

            // reset server errors
            // TODO: it would be nice to reset specific server errors dynamically using vue, but this will take a bit more thought and work.
            this.serverErrors = [];

            if (this.title && this.domain && this.description && this.tracker_type) {
                axios
                    .post(`/api/patients/${this.patient.id}/goals`, {
                        title: this.title,
                        is_shared: this.is_shared,
                        domain_id: this.domain,
                        description: this.description,
                        tracker_type: this.tracker_type,
                        parameters: this.parameters,
                        progress: this.progress,
                    })
                    .then(() => {
                        mixpanel.track("Goals - Add new goal", {
                            Domain: this.domains.find(domain => domain.id == this.domain).name,
                            Method: this.tracker_type,
                        });
                        this.$emit("refresh-goals");
                        this.resetComponent();
                    })
                    .catch(error => {
                        this.loading = false;
                        // loop through all errors
                        //  errors variable is an object/dictionary
                        let errors = error.response.data.errors;
                        for (let key in errors) {
                            let errorsForType = errors[key];
                            // The errors from the servers may or may not be in the form of an array,
                            // so we need to "normalize" them by simply looping through the list
                            // and adding each error as a simple string.
                            if (Array.isArray(errorsForType)) {
                                for (let errorArray of errorsForType) {
                                    if (Array.isArray(errorArray)) {
                                        // each type validation type can have multiple reasons for failing
                                        for (let e of errorArray) {
                                            this.serverErrors.push(e);
                                        }
                                    } else {
                                        // handles the case when error is unknown
                                        this.serverErrors.push(errorArray);
                                    }
                                }
                            } else {
                                this.serverErrors.push(errorsForType);
                            }
                        }
                    });
            }
        },

        resetComponent() {
            this.title = null;
            this.is_shared = 0;
            this.domain = null;
            this.description = null;
            this.tracker_type = null;
            this.targets = [];
            this.target = null;
            this.percent = null;
            this.progress = 0;
            this.parameters = {
                success: 0,
                attempts: 0,
            };
            this.loading = false;
            this.serverErrors = [];
        },
    },
};
</script>

<style scoped>
.custom-input {
    color: #495057;
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid #ced4da;
    -webkit-transition: border-color 0.15s ease-in-out, -webkit-box-shadow 0.15s ease-in-out;
    transition: border-color 0.15s ease-in-out, -webkit-box-shadow 0.15s ease-in-out;
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out,
        -webkit-box-shadow 0.15s ease-in-out;
    padding: 0.25rem 0.5rem;
    font-size: 0.7875rem;
    line-height: 1.5;
    border-radius: 0.2rem;
}
</style>
